function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import CloseButton from 'swag-client-common/components/ui/close-button';
import { ConfigurableLink } from 'swag-client-common/components/utils/configurable-link';
import { SWAG_IN_A_BOX_LANDING } from 'swag-client-common/constants';
import { mobMenuState } from 'swag-client-common/utils/constants';
import classnames from 'classnames';
import Drawer from 'material-ui/Drawer';
import { hasMyCompanyItem } from 'swag-client-common/utils/my-company.util';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './side-menu.scss';
import Category from './components';
import { SideMenuSavedDesign } from './components/side-menu-saved-design';
export class SideMenu extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      subcategories: []
    });
    _defineProperty(this, "handleMenuClick", () => {
      this.props.changeIsShownMobMenuState(true, mobMenuState.CATEGORIES);
    });
  }
  renderUserLinks() {
    const {
      onSignupClick,
      onLoginClick,
      onLogout,
      isLoggedIn,
      passwordNotSet,
      useHardLinks,
      userRole,
      isApiAccessEnabled,
      lastInventoryId,
      userIsHeadOfCompanyDepartment,
      orderApprovalFlow,
      showInventoryLink,
      routeNavigationConfirmation,
      onToggle,
      open,
      isResellerAdminMode
    } = this.props;
    if (isLoggedIn) {
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(classes.column, classes.block)
      }, /*#__PURE__*/React.createElement(ConfigurableLink, {
        routeNavigationConfirmation: routeNavigationConfirmation,
        isHardLink: useHardLinks && !routeNavigationConfirmation,
        link: APP_ROUTES.ACCOUNT_ORDERS,
        onClick: () => onToggle(false),
        tabIndex: open ? 0 : -1
      }, "My orders"), showInventoryLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
        routeNavigationConfirmation: routeNavigationConfirmation,
        isHardLink: !routeNavigationConfirmation,
        link: `/inventory/${lastInventoryId}`,
        onClick: () => onToggle(false),
        className: classes.hideForMobile,
        tabIndex: open ? 0 : -1
      }, "My inventory"), hasMyCompanyItem({
        userRole,
        userIsHeadOfCompanyDepartment,
        orderApprovalFlow
      }) && /*#__PURE__*/React.createElement(ConfigurableLink, {
        link: APP_ROUTES.MY_COMPANY,
        routeNavigationConfirmation: routeNavigationConfirmation,
        isHardLink: useHardLinks && !routeNavigationConfirmation,
        onClick: () => onToggle(false),
        tabIndex: open ? 0 : -1
      }, "My company"), isApiAccessEnabled && /*#__PURE__*/React.createElement(ConfigurableLink, {
        dataLink: "ApiAccessSettings",
        isHardLink: useHardLinks && !routeNavigationConfirmation,
        routeNavigationConfirmation: routeNavigationConfirmation,
        link: APP_ROUTES.ACCOUNT_PUBLIC_API,
        onClick: () => onToggle(false),
        tabIndex: open ? 0 : -1
      }, "Public API"), /*#__PURE__*/React.createElement(ConfigurableLink, {
        routeNavigationConfirmation: routeNavigationConfirmation,
        isHardLink: useHardLinks && !routeNavigationConfirmation,
        link: APP_ROUTES.SIZE_SUBMISSIONS,
        onClick: () => onToggle(false),
        tabIndex: open ? 0 : -1
      }, "Size Submissions"), /*#__PURE__*/React.createElement(SideMenuSavedDesign, {
        useHardLinks: useHardLinks,
        onToggle: onToggle,
        routeNavigationConfirmation: routeNavigationConfirmation,
        tabIndex: open ? 0 : -1
      }), !isResellerAdminMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfigurableLink, {
        routeNavigationConfirmation: routeNavigationConfirmation,
        isHardLink: useHardLinks && !routeNavigationConfirmation,
        link: APP_ROUTES.PROFILE_SETTINGS,
        onClick: () => onToggle(false),
        tabIndex: open ? 0 : -1
      }, "Profile settings"), /*#__PURE__*/React.createElement(ConfigurableLink, {
        routeNavigationConfirmation: routeNavigationConfirmation,
        isHardLink: useHardLinks && !routeNavigationConfirmation,
        link: APP_ROUTES.PROFILE_PASSWORD,
        onClick: () => onToggle(false),
        tabIndex: open ? 0 : -1
      }, passwordNotSet ? 'Set Password' : 'Change Password')), /*#__PURE__*/React.createElement(ConfigurableLink, {
        className: classes.drawerItem,
        onClick: () => {
          onLogout();
          onToggle(false);
        },
        routeNavigationConfirmation: routeNavigationConfirmation,
        isHardLink: !routeNavigationConfirmation,
        link: APP_ROUTES.HOME,
        tabIndex: open ? 0 : -1
      }, "Logout"));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.column, classes.block)
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.drawerItem,
      onClick: onLoginClick,
      "data-span": "Login"
    }, "Log In"), /*#__PURE__*/React.createElement("span", {
      className: classes.drawerItem,
      onClick: onSignupClick,
      "data-span": "SignUp"
    }, "Sign Up"));
  }
  renderCategoriesList() {
    const {
      categories,
      selectedCategoryIds
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.column
    }, categories.map(category => /*#__PURE__*/React.createElement(Category, {
      hideMenu: () => this.props.changeIsShownMobMenuState(false, mobMenuState.MAIN),
      key: category.name,
      category: category,
      selectedCategoryIds: selectedCategoryIds,
      routeNavigationConfirmation: this.props.routeNavigationConfirmation,
      useHardLinks: this.props.useHardLinks
    })));
  }
  renderMainMenuList() {
    const {
      useHardLinks,
      routeNavigationConfirmation,
      onToggle,
      hideLinkFavourites = true,
      showSwagDistributionLink,
      showBuildABoxLink,
      showSwagAutomationLink,
      showTalkToUsLink,
      showOurStoryLink,
      showBlogLink,
      showWhatWeOfferLink,
      open
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.column
    }, /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      link: APP_ROUTES.ALL_SWAG,
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Browse products"), !hideLinkFavourites && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      link: APP_ROUTES.FAVORITE_PRODUCTS,
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Favorite products"), showSwagDistributionLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      link: APP_ROUTES.DISTRIBUTE,
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Swag Distribution"), showBuildABoxLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      link: SWAG_IN_A_BOX_LANDING,
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Build a Box"), showSwagAutomationLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      link: APP_ROUTES.AUTOMATION,
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Swag Automation"), showTalkToUsLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      link: APP_ROUTES.CONTACT,
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Talk to us"), showOurStoryLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      link: APP_ROUTES.OUR_STORY,
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Our story"), showBlogLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: !routeNavigationConfirmation,
      link: "/blog",
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "Blog"), showWhatWeOfferLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
      routeNavigationConfirmation: routeNavigationConfirmation,
      isHardLink: !routeNavigationConfirmation,
      link: "/what-we-offer",
      onClick: () => onToggle(false),
      tabIndex: open ? 0 : -1
    }, "What we offer"), this.renderUserLinks());
  }
  render() {
    const {
      open,
      onToggle,
      className,
      state
    } = this.props;
    return /*#__PURE__*/React.createElement(Drawer, {
      docked: false,
      width: 320,
      open: open,
      openSecondary: true,
      className: className,
      containerStyle: {
        overflow: 'visible'
      },
      onRequestChange: () => onToggle(false)
    }, open && /*#__PURE__*/React.createElement("div", {
      className: classes.drawerContainer
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.menu
    }, /*#__PURE__*/React.createElement(CloseButton, {
      className: classnames({
        [classes.close]: true,
        [classes.isShowButton]: open
      }),
      onClick: () => onToggle(false),
      dataButton: "Close"
    }), state), /*#__PURE__*/React.createElement("div", {
      className: classes.scrollable
    }, state === mobMenuState.MAIN && this.renderMainMenuList(), state === mobMenuState.CATEGORIES && this.renderCategoriesList())));
  }
}